import React from 'react';
import Til from '../images/til.svg';
import Fade from 'react-reveal/Fade';
class Hero extends React.Component {
 

    render(){ 
      let blockOrNot = (this.props.scrollTop > 0) ? "block" : "none"
        return (
         
              <div className="hero" >
                  <div className="presentation">
                  <Fade >
                  <h1> Hello, I am João. <br/> Designer & Front-end Developer  </h1>
                  </Fade>
                 
                  </div>
                
                </div>
         
               
            
        );
    } 
}

export default Hero;